import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../services/user.service';
import { SessionService } from '../../services/session/session.service';
import {TokenStorageService} from "../../services/storage/token-storage.service";

@Component({
    selector: 'app-summary-create-institution',
    templateUrl: './summary-create-institution.component.html',
    styleUrls: ['./summary-create-institution.component.css'],
    standalone: false
})
export class SummaryCreateInstitutionComponent implements OnInit {
  loading: boolean = false;
  name: any;
  code: any;
  publicKey: any;
  appKey: any;
  appSecret: any;
  masterAccountNumber: any;
  openApiEnabled: any;
  fixEnabled: any;
  boApisEnabled: any;
  depositAutoApproval: any;
  withdrawAutoApproval: any;
  loadingBankAcc: boolean = false;
  loadingBank: boolean = false;
  isTableEmptyBank: boolean = false;
  isTableEmpty: boolean = false;
  instBankList: any;
  customerDetails: any;
  bankDetails: any;
  loadingCustomerProfile: boolean = false;
  form: FormGroup = new FormGroup({
    publicKey: new FormControl(''),
    appKey: new FormControl(''),
    appSecret: new FormControl(''),
    masterAcc: new FormControl(''),
  });
  instCustomerProfile: any;
  isTableEmptyProfile: boolean = false;
  isSelectRow: boolean = false;
  selectedUserIndex: number = -1;
  customerDetailsCP: any;
  isTableEmptyCP: boolean = false;
  customerName: any;
  selectedUserIndexSP: number = -1;
  loadingSubscriptionPackage: boolean = false;
  isTableEmptyPackage: boolean = false;
  instSubscriptionPackages: any;
  subsPackages: any;
  loadingCP: boolean = false;
  isSelectRowCP: boolean = false;
  isSelectRowSP: boolean = false;
  packageName: any;
  loadingExchanges: boolean = false;
  isTableEmptyExchange: boolean = false;
  Exchanges: any;
  instForm: FormGroup = new FormGroup({});
  institution: any;
  errorMessage: any;
  originalData: any;
  con: any;
  env:any;
  constructor(
    private toastr: ToastrService,
    private userService: UserService,
    private formBuilder: FormBuilder,
    private session: SessionService,
    private tokenStorage: TokenStorageService
  ) { }

  ngOnInit(): void {
    this.initializeInstitutionForm();
    this.getCountryCode();
    this.env = this.tokenStorage.getUserEnv();
  }
  loadMethods() {
    this.code = this.session.getItem("newInstCode");
    this.getInstitution(this.code);

  }
  getCountryCode(){
    this.userService.getIp().subscribe((ip) => {
      this.userService.getCountryCode(ip).subscribe((code) => {
        const contryCode = JSON.parse(code).country_calling_code;
        this.instForm.controls['institutionContactNo'].setValue(contryCode+"-00000000");
        this.con = contryCode;

      });


    });
  }

  initializeInstitutionForm(): void {
    this.instForm = this.formBuilder.group({
      institutionCode: [''],
      institutionName: [''],
      institutionAddress: [''],
      institutionContactNo: [''],
      contactNo: [''],
      // institutionFaxNo: [''],
      institutionEmail: [''],
      FixApiEnableCheck: [''],
      AccountApiEnableCheck: [''],
      DwmEnableCheck: [''],
      DepositAutoEnableCheck: [''],
      WithdrawAutoEnableCheck: [''],
      bypassBuyingPower: [''],
      publicKey: [''],
      appKey: [''],
      appSecret: [''],
      masterAccLastName: [''],
      masterAccContactNoMobile: [''],
      masterAccEmail: [''],
      masterAccProfession: [''],
      masterAccCountryID: [''],
      masterAccNationality: [''],
    });

  }

  loadData() {
    // Replace this with your API call or other data loading logic
    this.originalData = {
      institutionCode: this.code,
      institutionName: this.institution.institutionName,
      institutionAddress: this.session.getItem("institutionAddress"),
      contactNo: this.session.getItem("institutionContactNo"),
      // institutionFaxNo: this.session.getItem("institutionFaxNo") ? this.session.getItem("institutionFaxNo") : "N/A",
      institutionEmail: this.institution.email,
      FixApiEnableCheck: this.institution.fixEnabled ,
      AccountApiEnableCheck: this.institution.boApisEnabled,
      DwmEnableCheck: this.institution.dwmApiEnabled,
      DepositAutoEnableCheck: this.institution.depositAutoApproval,
      WithdrawAutoEnableCheck: this.institution.withdrawAutoApproval,
      bypassBuyingPower: this.institution.buyingPower,
      publicKey: this.institution.publicKey,
      appKey: this.institution.appKey,
      appSecret: this.institution.appSecret ? "***********" : "-",
      masterAccLastName: this.customerDetails.lastName ? this.customerDetails.lastName : "N/A",
      masterAccContactNoMobile: this.customerDetails.mobile ? this.customerDetails.mobile.split('-')[1] : "N/A",
      masterAccEmail: this.customerDetails.email ? this.customerDetails.email : "N/A",
      masterAccProfession: this.customerDetails.profession ? this.customerDetails.profession : "N/A",
      masterAccCountryID: this.customerDetails.countryCode ? this.customerDetails.countryCode : "N/A",
      masterAccNationality: this.customerDetails.nationality ? this.customerDetails.nationality : "N/A",
    };

    // Set the form values to the loaded data
    this.instForm.patchValue(this.originalData);
  }

  getInstitution(code: any) {
    this.userService.getInstitution(code).subscribe({
      next: (data) => {
        if (data.status == 'SUCCESS') {
          this.institution = data.institutionList[0];
          this.masterAccountNumber = this.institution.masterAccountNumber;
          this.getSelectedInst();

        } else {
          this.errorMessage = data.reason;
          this.toastr.error(
            this.errorMessage,
            'Error getting institution'
          );
        }
      },
      error: (err) => {
        this.errorMessage = err.error.message;
        this.toastr.error(
          this.errorMessage,
          'Error getting institution'
        );
      },
    });
  }

  getSelectedInst() {
    if (
      this.masterAccountNumber != null ||
      this.masterAccountNumber != ''
    ) {
      this.loading = true;

      this.userService
        .getCustomerDetails(this.masterAccountNumber, 'asia')
        .subscribe((data1: any) => {

          this.loading = false;
          if (data1.status == 'SUCCESS') {
            if (data1.cashAccounts.length) {
              this.isTableEmpty = false;
            } else {
              this.isTableEmpty = true;
            }

            this.customerDetails = data1;
            this.loadData();
          } else {
            this.isTableEmpty = true;

          }
        });
    } else {
      this.isTableEmpty = true;
    }
    this.loadingExchanges = true;
    this.userService.getInstExchangesList(this.code, 'asia').subscribe((dataE: any) => {
      this.loadingExchanges = false;
      this.isTableEmptyExchange = false;

      if (dataE.status == 'SUCCESS') {
        this.Exchanges = dataE;

        if (
          this.Exchanges.list == null ||
          this.Exchanges.list == ''
        ) {
          this.isTableEmptyExchange = true;
        }
      } else {
        this.isTableEmptyExchange = true;
      }
    });


    this.loadingBankAcc = true;
    this.userService.getBankAccountDetails(this.code, "", 'asia').subscribe((data2: any) => {
      this.loadingBankAcc = false;
      this.isTableEmptyBank = false;

      if (data2.status == 'SUCCESS') {
        this.bankDetails = data2;

        if (
          this.bankDetails.bankAccountList == null ||
          this.bankDetails.bankAccountList == ''
        ) {
          this.isTableEmptyBank = true;
        }
      } else {
        this.isTableEmptyBank = true;
      }
    });


    this.loadingBank = true;
    this.userService.getInstBankList(this.code, 'asia').subscribe((data3: any) => {
      this.loadingBank = false;
      this.isTableEmptyBank = false;

      if (data3.status == 'SUCCESS') {
        this.instBankList = data3;

        if (
          this.instBankList.bankList == null ||
          this.instBankList.bankList == ''
        ) {
          this.isTableEmptyBank = true;
        }
      } else {
        this.isTableEmptyBank = true;
      }
    });

    this.loadingCustomerProfile = true;
    this.userService.getInstCustomerProfile(this.code, 'asia').subscribe((data4: any) => {
      this.loadingCustomerProfile = false;
      this.isTableEmptyProfile = false;

      if (data4.status == 'SUCCESS') {
        this.instCustomerProfile = data4;

        if (
          this.instCustomerProfile.profileList == null ||
          this.instCustomerProfile.profileList == ''
        ) {
          this.isTableEmptyProfile = true;
        }
      } else {
        this.isTableEmptyProfile = true;
      }
    });

    this.loadingSubscriptionPackage = true;
    this.userService.getInstSubscriptionPackageList(this.code, 'asia').subscribe((data5: any) => {
      this.loadingSubscriptionPackage = false;
      this.isTableEmptyPackage = false;

      if (data5.status == 'SUCCESS') {
        this.instSubscriptionPackages = data5;
        if (
          this.instSubscriptionPackages.packageList == null ||
          this.instSubscriptionPackages.packageList == ''
        ) {
          this.isTableEmptyPackage = true;
        }
      } else {
        this.isTableEmptyPackage = true;
      }
    });

  }



  selectedRowCP($event: any, customerNumber: any, userInded: number, customerName: any) {
    if (userInded === this.selectedUserIndex) {
      this.selectedUserIndex = -1;
      return;
    }
    this.customerName = customerName;
    this.selectedUserIndex = userInded;
    this.isSelectRowCP = true
    this.loadingCP = true;

    this.userService
      .getCustomerDetails(customerNumber, 'asia')
      .subscribe((data1: any) => {

        this.loadingCP = false;
        if (data1.status == 'SUCCESS') {
          if (data1.cashAccounts.length) {
            this.isTableEmptyCP = false;
          } else {
            this.isTableEmptyCP = true;
          }
          this.customerDetailsCP = data1;
        } else {
          this.isTableEmptyCP = true;
        }
      });

  }

  selectedRowSP($event: any, subsPackages: any, userIndedSP: number) {
    if (userIndedSP === this.selectedUserIndexSP) {
      this.selectedUserIndexSP = -1;
      return;
    }
    this.packageName = subsPackages.packageName;
    this.selectedUserIndexSP = userIndedSP;
    this.subsPackages = subsPackages;
    this.isSelectRowSP = true

    if (subsPackages.exchangeList.length) {
      this.isTableEmpty = false;
    } else {
      this.isTableEmpty = true;
    }


  }

}
